<script setup lang="ts"></script>

<template>
  <p :class="$style.error"><slot /></p>
</template>

<style lang="scss" module>
.error {
  color: $color-caution-accent;
  font-weight: bold;
}
</style>
